import { useEffect, useState } from "react";
import { MediaRecorder, register } from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";
import { pad, handleFileSelect, uploadChunk, commitBlockList } from "./upload_audio/audioUploadHelper";
// import "react-toastify/dist/ReactToastify.css";
// import { toast } from "react-toastify";

export const  getquizid = window.location.pathname.split("/")[3];

const MIN_BLOB_SIZE = 300 * 1024;
var partSize = 0, parts = [];
var maxBlockSize = 600 * 1024;//Each file will be split in 256 KB.
var selectedFile = null;
var blockIds = [];
let uploadPromises = [];
var submitUri = null;
var Audiofilename = "";
const useSpeechRecorder = (audioUploadurl, Studentname, data_type, data_page_id, data_exercise_id, data_section_id, setAudioanalyzer, setIsaudioUpload) => {
  const [base64, setBase] = useState("");
  const [audioURL, setAudioURL] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState(null);
  const [isWavUsed, setIsWavUsed] = useState(false);
  if (data_type === "Assessment")
  {
    Audiofilename = `${Studentname}-${getquizid}-${data_section_id}${data_page_id}${data_exercise_id}.wav`;
  }
  else {
    Audiofilename = `${Studentname}-${getquizid}.wav`;
  }

  const handleFile = (file) => {
    const Urisubmit = handleFileSelect(file, audioUploadurl);
    selectedFile = file;
    maxBlockSize = selectedFile.size;
    submitUri = Urisubmit;
  };

  // Function to upload file in blocks
  const uploadFileInBlocks = () => {
    const fileContent = selectedFile.slice(0, maxBlockSize);
    const blockId = `block-${pad(blockIds.length, 6)}`;
    const encodedBlockId = btoa(blockId);
    blockIds.push(encodedBlockId);

    const reader = new FileReader();
    reader.onloadend = function (evt) {
      if (evt.target.readyState === FileReader.DONE) {        
        uploadPromises.push(uploadChunk(submitUri, evt.target.result, encodedBlockId));
      }
    };
    reader.readAsArrayBuffer(fileContent);
  };

  const finalizeUpload = (retryCount = 3) => {
    Promise.all(uploadPromises)
      .then(() => commitBlockList(submitUri, blockIds, selectedFile))
      .then(url => {
          setBase(url);
          setAudioURL(url);
          setIsaudioUpload(true);
          setTimeout(() => {
          localStorage.setItem(`audioUpload${getquizid}`,true)
          }, 100);
          blockIds = [];
          uploadPromises = [];
      })
      .catch(error => {
          console.error("Error committing block list:", error);
          if (retryCount > 0) {
              console.log(`Retrying commitBlockList in 300ms...`);
              setTimeout(() => finalizeUpload(retryCount - 1), 300);
          } else {
              console.error("Failed to commit block list after multiple attempts.");              
              localStorage.setItem(`audioUpload${getquizid}`,true)
              blockIds = [];
              uploadPromises = [];
          }
      });
  };

  useEffect(() => {
    async function fetchMyAPI() {
      try {
        if (!MediaRecorder.isTypeSupported("audio/wav")) {
          await register(await connect());
        }
      } catch (error) {
        console.error("Error registering the encoder:", error);
      }
    }
    if (!isWavUsed) {
      fetchMyAPI();
      setIsWavUsed(true);
    }
  }, [isWavUsed]);
  useEffect(() => {
    if (recorder === null) {
      if (isRecording) {
        requestRecorder(setAudioanalyzer).then(setRecorder, console.error);
      }
      return;
    }

    if (isRecording) {
      recorder.start(3000);
    } else {
      recorder.stop();
    }

    const handleData = (e) => {
      const blob_evt = e.data;
      partSize += blob_evt.size;
      parts.push(blob_evt);
      if (partSize >= MIN_BLOB_SIZE) {
        const blob = new Blob(parts, {type: 'audio/wav'});
        const file = new File([blob], Audiofilename, {type: 'audio/wav'});
        handleFile(file);
          partSize = 0;
          parts = [];
        setTimeout(() => {
          uploadFileInBlocks()
        },100);
      }
    };
    recorder.onstop = (e) => {
      if(audioURL !== "")
      {
        setAudioURL("");
      }
      if(partSize > 0)
      {
        const blob = new Blob(parts, {type: 'audio/wav'});
        const file = new File([blob], Audiofilename, {type: 'audio/wav'});
        handleFile(file);
        partSize = 0;
        parts = [];
        uploadFileInBlocks();        
      }
      setTimeout(() => {
        finalizeUpload();
      }, 200);
    };

    recorder.addEventListener("dataavailable", handleData);
    return () => recorder.removeEventListener("dataavailable", handleData);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recorder, isRecording]);

  const startRecording = () => {
    setIsaudioUpload(false);
    setIsRecording(true);
  };

  const stopRecording = () => {
    setIsRecording(false);
    if (blockIds.length === 0 || uploadPromises.length === 0){
      localStorage.setItem(`audioUpload${getquizid}`,true)
    }
  };

  return [base64, isRecording, startRecording, stopRecording];
};

async function requestRecorder(setAudioanalyzer) {
  // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  // return new MediaRecorder(stream);
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  window.localstream =stream;
  const mediaRecoder = new MediaRecorder(stream, { mimeType: "audio/wav" });
  setAudioanalyzer(stream)
  return mediaRecoder;
}
export default useSpeechRecorder;
